<script lang="ts" setup>
  import { computed, ref, watch, nextTick } from 'vue';
  import store from '@/common/store';
  import BottomNotification from '@/common/components/notification-center/BottomNotification.vue';

  const GAP = 16;

  type TypeBottomNotification = InstanceType<typeof BottomNotification>;

  const visibleNotifications = computed(() => store.getters['notifications/visibleBottomNotifications']);
  const notificationRef = ref<TypeBottomNotification[] | null>(null);

  watch(visibleNotifications, async (notifications) => {
    if (!notifications.length) return;

    // Wait all ticks to ensure that notifications are rendered
    // and have their height calculated
    await nextTick();
    await nextTick();

    notificationRef.value?.forEach((instance, index, arr) => {
      const offset = arr.slice(0, index).reduce(
        (acc, it) => acc + (it.$el as HTMLElement).offsetHeight + GAP, GAP
      );
      (instance.$el as HTMLElement).style.bottom = `${offset}px`;
    });
  }, { immediate: true });
</script>

<template>
<div data-component-name="bottom-notifications">
  <bottom-notification data-component-name="bottom-notification"
    v-for="notification in visibleNotifications"
    :key="notification.id"
    ref="notificationRef"
    :notification="notification"
  />
</div>
</template>
